import ShareCampaign from './share_campaign_textarea'
import { connect } from 'react-redux'
import {
  campaignUrlForDisplay,
  campaignUrlWithMeDomain,
} from 'lib/campaign_url'
import _get from 'lodash/get'
import { getI18n } from 'client/i18n'
import { getCategoryLabel } from 'lib/category'
import { canShareSelector } from 'redux/selectors/share'
import { formatMoney, formatDateShort } from 'client/griffin'
import { getCampaignSelector } from 'redux/selectors/campaign'

const i18n = getI18n('components/pages/crowdfunding/pool_share')

const mapStateToProps = (state, ownProps) => {
  const canShare = canShareSelector(state)
  const campaign = getCampaignSelector(state, ownProps)
  const urlWithMeDomain = campaignUrlWithMeDomain(campaign.id)
  const emailSubjectText = i18n('email_subject')
  const emailBodyText = i18n('share_message', {
    goalAmount: formatMoney(campaign.currency, campaign.goal),
    expiryDate: formatDateShort(campaign.end_date),
    shareUrl: urlWithMeDomain,
    categoryName: getCategoryLabel(state, campaign.category).toLowerCase(),
  })
  const emailBody = _get(emailBodyText, 'props.children', emailBodyText)
  const emailSubject = _get(
    emailSubjectText,
    'props.children',
    emailSubjectText
  )

  let props = {
    shareable: true,
    shareUrl: urlWithMeDomain,
    displayUrl: campaignUrlForDisplay(campaign.id),
    appId: state.social.app_id,
    emailBody,
    emailSubject,
    isMobile: state.device_info.isMobile,
  }

  if (!canShare) {
    props.showFacebook = false
    props.showMessenger = false
    props.showTwitter = false
    props.showWhatsApp = false
    props.showEmail = false
    props.showSms = false
  }

  return props
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShareCampaign)
